import { useTranslation } from 'react-i18next';

import Spinner from '../../../../styledComponents/Spinner/Spinner';

import OverviewOptions from '../../../../styledComponents/Overview/OverviewOptions/OverviewOptions';

import {
  StyledLeftContainer,
  StyledRightContainer,
  DetailsWrapper,
  StyledDeleteButton,
} from '../../Common/memberOverviewMembers.styles';

import {
  canEditDOCMembershipsOptionsPermissions,
  canRemoveDOCMembershipPermissions,
} from '../../../../config/accessPolicies/accessPolicies';
import MemberOverviewDetails from '../../Common/MemberOverviewDetails/MemberOverviewDetails';
import { ProductType } from '../../../../models/ProductType';

import { DutyOfCareMembershipOptions } from '../../../../models/enums/DutyOfCareMembershipOptions';
import { useDOCMembershipDetails } from '../Common/docMembershipOverview.hooks';
import { docOverviewTablePermissions } from '../Common/docMembershipOverview.const';
import DOCMembershipMemberTable from '../DOCMembershipMemberTable/DOCMembershipMemberTable';
import EditDOCMembershipOptionsModal from '../Modals/EditDOCMembershipOptionsModal/EditDOCMembershipOptionsModal';

interface DOCMembershipExpiredDetailsProps {
  membershipId: string;
  productType?: ProductType;
  canBeRemoved?: boolean;
}
const DOCMembershipExpiredDetails = ({
  membershipId,
  productType,
  canBeRemoved,
}: DOCMembershipExpiredDetailsProps) => {
  const { t } = useTranslation();

  const {
    dataLoading,
    membershipDetails,
    changeRenewFlagHandler,
    deleteMembershipHandler,
    onRowClickHandler,
    onEditMembershipOptionsHandler,
  } = useDOCMembershipDetails(membershipId, productType);

  if (dataLoading && !membershipDetails) {
    return <Spinner />;
  }
  return (
    <>
      <EditDOCMembershipOptionsModal id={membershipId} />
      <DetailsWrapper>
        <StyledLeftContainer>
          <DOCMembershipMemberTable
            data={membershipDetails?.members}
            dataLoading={dataLoading}
            onRenewFlagChange={changeRenewFlagHandler}
            onRowClick={onRowClickHandler}
            isExpiredMembershipsTable={false}
            permissions={docOverviewTablePermissions}
          />
        </StyledLeftContainer>
        <StyledRightContainer>
          <OverviewOptions
            onEditOptionsClick={onEditMembershipOptionsHandler}
            canEditOptionsPermissions={canEditDOCMembershipsOptionsPermissions}
            data={membershipDetails}
            options={[
              { value: DutyOfCareMembershipOptions.SendWelcomeEmail },
              { value: DutyOfCareMembershipOptions.EmailOptOut },
            ]}
          />
          <MemberOverviewDetails
            data={{
              effectiveDateFrom: membershipDetails?.effectiveDate,
              effectiveDateTo: membershipDetails?.expirationDate,
              organizationContractName:
                membershipDetails?.organizationContractName,
            }}
            canBeRenewed={false}
          />
          {canBeRemoved && (
            <StyledDeleteButton
              permissions={canRemoveDOCMembershipPermissions}
              styleType="delete"
              onClick={deleteMembershipHandler}
            >
              {t('buttons.delete-membership')}
            </StyledDeleteButton>
          )}
        </StyledRightContainer>
      </DetailsWrapper>
    </>
  );
};

export default DOCMembershipExpiredDetails;
